// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
    position: absolute;
    top: 5px;
    width: 3px;
    height: 30px;
    border-radius: 2px;
    background: var(--admin-color);
}


.hand {
    cursor: pointer;
}

.not_select {
    background: #ffff;
}

.icon_select,.expand .nav-text {
    color: var(--admin-color);
}

.icon_notselect {
    color: black;

}
.sidebar .sidebar-inner>li>span{
    padding: 10px 25px !important;
}
.ec-brand .ec-brand-name{
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: black;
}

.ec-left-sidebar-Wrapper{
    margin-top: 47px!important;
}
.material-symbols-outlined{
    font-size: 20px !important;
}

.mdi-view-dashboard-outline{
    font-size: 20px !important;
}

.simplebar-content ul .heading:hover {
    background-color: #edf3f4;
}


.simplebar-content  .sub_heading span p:hover {
    color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/SideNav/SideNav.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;;AAEhB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,uBAAuB;AAC3B","sourcesContent":[".select {\n    position: absolute;\n    top: 5px;\n    width: 3px;\n    height: 30px;\n    border-radius: 2px;\n    background: var(--admin-color);\n}\n\n\n.hand {\n    cursor: pointer;\n}\n\n.not_select {\n    background: #ffff;\n}\n\n.icon_select,.expand .nav-text {\n    color: var(--admin-color);\n}\n\n.icon_notselect {\n    color: black;\n\n}\n.sidebar .sidebar-inner>li>span{\n    padding: 10px 25px !important;\n}\n.ec-brand .ec-brand-name{\n    font-size: 18px;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    color: black;\n}\n\n.ec-left-sidebar-Wrapper{\n    margin-top: 47px!important;\n}\n.material-symbols-outlined{\n    font-size: 20px !important;\n}\n\n.mdi-view-dashboard-outline{\n    font-size: 20px !important;\n}\n\n.simplebar-content ul .heading:hover {\n    background-color: #edf3f4;\n}\n\n\n.simplebar-content  .sub_heading span p:hover {\n    color: black !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
